import React, { useEffect, useState } from 'react';
import { Grid, Modal } from '@material-ui/core';
import { DialogProps } from '@material-ui/core/Dialog';
import {
  createStyles,
  makeStyles,
  Theme,
  withStyles
} from '@material-ui/core/styles';
import _ from 'lodash';
import { useRecoilState } from 'recoil';
import {
  additionalCostData,
  progressFlgState,
  workingBudgetData,
  workingBudgetInfo,
  workingBudgetVendor
} from '../../GlobalState';
import {
  ModalCancelButton,
  ModalDeleteButton,
  ModalSubmitButton
} from '../parts/cloudStorage/style/style';
import {
  TypeLayer,
  TypeVendorInfo,
  TypeWorkingBudgetInfo
} from '../../types/WorkingBudgetPage';
import {
  addVender,
  deleteWorkingBudgetVender,
  updateTotallingInfo
} from '../../apicalls/WorkingBudgetPage';
import {
  deleteWorkingBudgetVenderData,
  recalculation,
  setDrawingData,
  updateWorkingBudgetData
} from '../../utils/WorkingBudgetPage';
import { NOT_LOGGED_IN } from '../../const/Const';

type TProps = {
  openDeleteModal: boolean;
  setOpenDeleteModal: React.Dispatch<React.SetStateAction<boolean>>;
  changeLoggedInData: (newData: string) => void;
  setErrorMessage: React.Dispatch<React.SetStateAction<string>>;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setSuccessMessage: React.Dispatch<React.SetStateAction<string>>;
  setOpenSuccess: React.Dispatch<React.SetStateAction<boolean>>;
  workingBudgetId: number;
};

export const VenderDeleteModal: React.FC<TProps> = (props: TProps) => {
  const {
    openDeleteModal,
    setOpenDeleteModal,
    changeLoggedInData,
    setErrorMessage,
    setOpen,
    setSuccessMessage,
    setOpenSuccess,
    workingBudgetId
  } = props;

  const classes = useStyles();
  const [fullWidth] = useState(true);
  const [workingBudget, setWorkingBudget] = useRecoilState(workingBudgetData);
  const [vendor, setVendor] = useRecoilState(workingBudgetVendor);
  const [additionalCost, setAdditionalCost] =
    useRecoilState(additionalCostData);
  const [totallingInfo, setTotallingInfo] = useRecoilState(workingBudgetInfo);
  const [, setProgressFlg] = useRecoilState<boolean>(progressFlgState);
  const [confirmation, setConfirmation] = useState<boolean>(false);
  const [selectVender, setSelectVender] = useState<TypeVendorInfo>();
  const [selectVenderId, setSelectVenderId] = useState<number>();

  const deleteVendor = () => {
    if (confirmation) {
      setProgressFlg(true);
      if (workingBudget) {
        // 一旦保存
        updateWorkingBudgetData(
          workingBudget,
          additionalCost,
          vendor,
          totallingInfo,
          workingBudgetId,
          changeLoggedInData,
          setErrorMessage,
          setOpen,
          setSuccessMessage,
          setOpenSuccess,
          setWorkingBudget,
          setVendor,
          setAdditionalCost,
          false
        )
          .then(async () => {
            const cloneVendor: TypeVendorInfo[] | undefined =
              _.cloneDeep(vendor);
            const filteredData = cloneVendor?.find(
              item => item.vendor_id == selectVenderId
            );
            if (filteredData && filteredData.id) {
              const cloneTotallingInfo = _.cloneDeep(totallingInfo);
              if (cloneTotallingInfo) {
                // 業者削除
                return await deleteWorkingBudgetVenderData(
                  filteredData,
                  workingBudgetId,
                  changeLoggedInData,
                  setErrorMessage,
                  setOpen,
                  setSuccessMessage,
                  setOpenSuccess,
                  setOpenDeleteModal,
                  setWorkingBudget,
                  setVendor,
                  setAdditionalCost,
                  cloneTotallingInfo
                );
              }
            }
          })
          .finally(() => setProgressFlg(false));
      }
    } else {
      setConfirmation(true);
      setSelectVender(vendor?.find(v => v.vendor_id == selectVenderId));
    }
  };

  return (
    <Modal
      open={openDeleteModal}
      onClose={() => setOpenDeleteModal(false)}
      aria-labelledby='simple-modal-title'
      aria-describedby='simple-modal-description'
      className={classes.modal}
    >
      <Grid container className={classes.subpaper}>
        <Grid item xs={12} className={classes.container}>
          <div style={{ textAlign: 'center' }}>
            <h1 style={{ margin: 24, fontSize: 24 }}>業者を削除</h1>
            {confirmation ? (
              <p style={{ color: 'red' }}>
                選択した業者を削除しますか？
                <br />
                この操作は取り消せません。
              </p>
            ) : (
              <p>削除する業者を選択してください</p>
            )}
          </div>
        </Grid>

        <div className={classes.body}>
          <div className={classes.select}>
            {confirmation ? (
              <>{selectVender?.name}</>
            ) : (
              <>
                {vendor &&
                  vendor.length > 0 &&
                  vendor.map(item => (
                    <div className={classes.venderRow}>
                      <input
                        type='radio'
                        name='vendor'
                        value={item.vendor_id}
                        onChange={v =>
                          setSelectVenderId(Number(v.target.value))
                        }
                      />
                      <label>{item.name}</label>
                    </div>
                  ))}
              </>
            )}
          </div>
        </div>

        <Grid item xs={12} className={classes.modalFooter}>
          <ModalCancelButton
            variant='contained'
            onClick={() => {
              setOpenDeleteModal(false);
            }}
          >
            キャンセル
          </ModalCancelButton>
          <ModalDeleteButton
            disabled={!selectVenderId}
            variant='contained'
            onClick={deleteVendor}
          >
            削除する
          </ModalDeleteButton>
        </Grid>
      </Grid>
    </Modal>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    cancelButton: {
      backgroundColor: '#bdbdbd',
      color: '#fff',
      '&:hover': {
        backgroundColor: '#cccccc',
        boxShadow: 3
      }
    },
    submitButton: {
      backgroundColor: '#007dff',
      color: '#fff',
      '&:hover': {
        backgroundColor: '#2691ff',
        boxShadow: 3
      }
    },
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    subpaper: {
      backgroundColor: theme.palette.background.paper,
      borderRadius: theme.spacing(2),
      boxShadow: theme.shadows[5],
      width: '50%',
      maxHeight: '90vh',
      overflowY: 'scroll'
    },
    container: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    body: {
      backgroundColor: theme.palette.background.paper,
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      height: 200,
      justifyContent: 'center',
      maxHeight: 300,
      overflowY: 'auto'
    },
    modalFooter: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderTop: '1px solid #cfcfcf',
      padding: 30
    },
    select: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      width: '60%'
    },
    venderRow: {
      display: 'flex',
      justifyContent: 'flex-start'
    }
  })
);
